<div fxLayout="column" fxLayout.xs="column" fxLayoutAlign="start center" class="full-width">
  <ng-container *ngIf="screen === 'intro'">
    <img src="assets/images/audio.png" title="Check Headset" alt="Check Headset" class="icon-audio" />
    <h2>{{ 'user.title.please_read' | translate }}</h2>
    <mat-card class="mat-card-customize pa-0">
      <mat-card-content>
        <h3 class="text-guide" [innerHTML]="'user.content.you_should1' | translate ">
        </h3>
        <h3 class="text-guide" [innerHTML]="'user.content.you_should2' | translate ">
        </h3>
        <h3 class="text-guide" [innerHTML]="'user.content.you_should3' | translate ">
        </h3>
      </mat-card-content>
    </mat-card>
  </ng-container>

  <ng-container *ngIf="screen === 'audio-device'">
    <div *ngIf="!hasAudioSettings ;else ReadBlock">
      <h2>{{ 'user.content.no_device' | translate }}</h2>
      <h2>{{ 'user.content.check' | translate }}</h2>
    </div>

    <ng-template #ReadBlock>
      <h2>{{ 'test_headset.content.select_headset' | translate }}</h2>

      <div fxLayout="row" fxLayoutAlign="start center" class="full-width">
        <div fxFlex="30">
          <span>{{ 'components.settings.audio_output' | translate }}</span>
        </div>
        <div fxFlex="70" fxLayoutAlign="end center">
          <mat-form-field class="mat-input-sm mat-input-no-padding" appearance="outline"
            *ngIf="audioOutputOptions.length !== 0; else NoAudioOutput">
            <mat-select [formControl]="audioOutputName" interface="popover" [disableControl]="testStatus !== 'notyet'">
              <mat-option value="*">Default</mat-option>
              <mat-option *ngFor="let outputOption of audioOutputOptions" [value]="outputOption.name">
                {{ outputOption.name}}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <ng-template #NoAudioOutput>
            <mat-form-field class="mat-input-sm mat-input-no-padding" appearance="outline">
              <mat-select disabled="true">
                <mat-option selected="true">
                  {{ 'NO_DEVICE_FOUND' | translate }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </ng-template>
        </div>
      </div>

      <mat-divider></mat-divider>

      <div fxLayout="row" fxLayoutAlign="start center" class="full-width">
        <div fxFlex="30">
          <span>{{ 'components.settings.audio_input' | translate }}</span>
        </div>
        <div fxFlex="70" fxLayoutAlign="end center">
          <mat-form-field class="mat-input-sm mat-input-no-padding" appearance="outline"
            *ngIf="audioInputOptions.length !== 0; else NoAudioInput">
            <mat-select [formControl]="audioInputName" [disableControl]="testStatus !== 'notyet'">
              <mat-option value="*">Default</mat-option>
              <mat-option *ngFor="let inputOption of audioInputOptions" [value]="inputOption.name">
                {{ inputOption.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <ng-template #NoAudioInput>
            <mat-form-field class="mat-input-sm mat-input-no-padding" appearance="outline">
              <mat-select disabled="true">
                <mat-option selected="true" *ngIf="showSelect">
                  {{ 'components.settings.no_device' | translate }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </ng-template>
        </div>
      </div>

      <mat-divider></mat-divider>

      <div *ngIf="testStatus === 'notyet'" fxLayoutAlign="center center" class="full-width text-center">
        <button mat-raised-button color="primary"
          (click)="startTesting()">{{ 'test_headset.button.start_testing'|translate }}</button>
      </div>

      <div *ngIf="testStatus === 'recording'" fxLayout="column" fxLayoutAlign="center center" class="full-width">
        <p>{{ 'test_headset.content.recording' | translate }}</p>

        <mat-progress-bar matLine mode="determinate" color="primary" [value]="timerRecording * 10"></mat-progress-bar>

        <!-- <div *ngIf="screen === 'go-recording'">
          <button mat-fab (click)="startRecording()" color="primary" color="warn">
            <mat-icon>settings_voice</mat-icon>
          </button>
        </div>
        <div *ngIf="screen === 'start-recording'" fxLayout="column">
          <button mat-fab (click)="stopRecording()" color="primary"><i class="material-icons">stop </i></button>
          <button mat-fab color="warn">
            <mat-icon>settings_voice</mat-icon>
          </button>
        </div>
        <div *ngIf="screen === 'stop-recording'">
          <button mat-fab (click)="playRecording()" class="round-button" color="primary" class="mat-green"><i
              class="material-icons">play_arrow</i></button>
        </div>
        <div *ngIf="screen === 'play-recording'">
          <button mat-fab (click)="stopPlayRecording()" class="round-button" color="primary"><i
              class="material-icons">stop</i></button>
        </div>
        <div *ngIf="screen === 'stop-play-recording'">
          <button (click)="cancel()" style="margin-right: 10px" color="primary"
            class="mat-green mat-raised-button mat-primary">{{'public.button.yes' | translate}}</button>
          <button (click)="goIntro()" color="primary"
            class="mat-blue mat-raised-button mat-primary">{{'public.button.no' | translate}}</button>
        </div> -->
      </div>

      <div *ngIf="testStatus === 'playing' || testStatus === 'played'" class="full-width">
        <p>{{ 'test_headset.content.playing' | translate }}</p>

        <mat-progress-bar *ngIf="testStatus === 'playing'" matLine mode="determinate" color="primary" [value]="timerPlaying * 10"></mat-progress-bar>

        <div fxLayout="row" fxLayoutAlign="center center" class="my-1">
          <div fxFlex>
            <button (click)="testOK()" color="primary"
              class="mat-green mat-raised-button mat-primary">{{'public.button.yes' | translate}}</button>
          </div>
          <div fxFlex>
            <button (click)="goRecording()" color="primary"
              class="mat-blue mat-raised-button mat-primary">{{'test_headset.button.no_hearing' | translate}}</button>
          </div>
        </div>
      </div>

    </ng-template>

  </ng-container>

</div>
